"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTeamData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const generateTeamData = (team = {}) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        id: (_a = team.id) !== null && _a !== void 0 ? _a : (0, tools_1.IDSource)(),
        name: (_b = team.name) !== null && _b !== void 0 ? _b : en_1.faker.person.firstName(),
        active: (_c = team.active) !== null && _c !== void 0 ? _c : true,
        created_at: (_d = team.created_at) !== null && _d !== void 0 ? _d : new Date(),
        level_1: (_e = team.level_1) !== null && _e !== void 0 ? _e : "",
        level_2: (_f = team.level_2) !== null && _f !== void 0 ? _f : "",
        level_3: (_g = team.level_3) !== null && _g !== void 0 ? _g : "",
        level_4: (_h = team.level_4) !== null && _h !== void 0 ? _h : "",
    };
};
exports.generateTeamData = generateTeamData;
